const smashGGApiKey = "SmashGGApiKey";

export const getSmashGGApiKey = () => localStorage.getItem(smashGGApiKey) ?? "";
export const setSmashGGApiKey = (key: string) => localStorage.setItem(smashGGApiKey, key);
